/**
 * Catálogo de menus do painel web (access_levels).
 * Manter alinhado com autentico-backend/src/config/menuAccessCatalog.js
 */

export const MENU_ACCESS_CATALOG = [
  { id: "home", label: "Início", group: "Geral", path: "/autentico/home", allowedLevels: null },
  { id: "registration", label: "Matrículas", group: "Matrículas", path: "/autentico/registration", allowedLevels: ["admin", "assistant", "coordinator", "secretary"] },
  { id: "register_requerimento", label: "Matrículas · Requerimento", group: "Matrículas (abas)", path: "/autentico/registration", allowedLevels: ["admin", "assistant", "coordinator", "secretary"] },
  { id: "register_matricular", label: "Matrículas · Matricular", group: "Matrículas (abas)", path: "/autentico/registration", allowedLevels: ["admin", "assistant", "coordinator", "secretary"] },
  { id: "register_consultar", label: "Matrículas · Consultar", group: "Matrículas (abas)", path: "/autentico/registration", allowedLevels: ["admin", "assistant", "coordinator", "secretary"] },
  { id: "register_censo", label: "Matrículas · Relatório de Matrículas", group: "Matrículas (abas)", path: "/autentico/registration", allowedLevels: ["admin", "coordinator"] },
  { id: "secretary", label: "Documentos", group: "Secretaria", path: "/autentico/secretary", allowedLevels: ["admin", "assistant", "coordinator", "secretary"] },
  { id: "teacher_diary", label: "Diário (professores)", group: "Pedagógico", path: "/autentico/teachers/diary", allowedLevels: ["admin"] },
  { id: "diary", label: "Agendas", group: "Pedagógico", path: "/autentico/diary", allowedLevels: ["admin", "assistant", "coordinator", "secretary"] },
  { id: "integrante", label: "Integral", group: "Pedagógico", path: "/autentico/integrante", allowedLevels: ["admin", "assistant", "coordinator", "secretary"] },
  { id: "announcements", label: "Comunicados", group: "Comunicação", path: "/autentico/announcements", allowedLevels: ["admin", "assistant", "coordinator", "secretary"] },
  { id: "individual_messages", label: "Mensagens", group: "Comunicação", path: "/autentico/individual-messages", allowedLevels: ["admin", "assistant", "coordinator", "secretary"] },
  { id: "study", label: "Estudos", group: "Pedagógico", path: "/autentico/study", allowedLevels: ["admin"] },
  { id: "grades", label: "Avaliações", group: "Pedagógico", path: "/autentico/grades", allowedLevels: ["admin", "assistant", "coordinator", "secretary"] },
  { id: "stats", label: "Estatísticas", group: "Pedagógico", path: "/autentico/stats", allowedLevels: ["admin", "assistant", "coordinator", "secretary"] },
  { id: "stats_questionnaires", label: "Estatísticas · Questionários (funcionários)", group: "Pedagógico (abas)", path: "/autentico/stats", allowedLevels: ["admin"] },
  { id: "questionnaires_admin", label: "Questionários", group: "Pedagógico", path: "/autentico/questionnaires", allowedLevels: ["admin", "coordinator", "director"] },
  { id: "events_admin", label: "Eventos", group: "Operações", path: "/autentico/events", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "events_view", label: "Eventos · Visualizar", group: "Eventos (funções)", path: "/autentico/events", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "events_manage", label: "Eventos · Criar e editar", group: "Eventos (funções)", path: "/autentico/events", allowedLevels: ["admin", "coordinator"] },
  { id: "events_publish", label: "Eventos · Publicar", group: "Eventos (funções)", path: "/autentico/events", allowedLevels: ["admin", "coordinator"] },
  { id: "events_cancel", label: "Eventos · Cancelar evento ou inscrição", group: "Eventos (funções)", path: "/autentico/events", allowedLevels: ["admin", "coordinator"] },
  { id: "events_finance", label: "Eventos · Inscrições, pagamentos e relatórios", group: "Eventos (funções)", path: "/autentico/events", allowedLevels: ["admin", "caixa"] },
  { id: "events_discount", label: "Eventos · Aplicar desconto", group: "Eventos (funções)", path: "/autentico/events", allowedLevels: ["admin"] },
  { id: "events_refund", label: "Eventos · Registrar reembolso", group: "Eventos (funções)", path: "/autentico/events", allowedLevels: ["admin"] },
  { id: "events_config", label: "Eventos · Configurar conta de pagamento", group: "Eventos (funções)", path: "/autentico/events", allowedLevels: ["admin"] },
  { id: "config", label: "Configurações (página)", group: "Configuração", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_user_register", label: "Config. · Cadastrar usuário", group: "Configuração (abas)", path: "/autentico/config", allowedLevels: ["admin", "coordinator"] },
  { id: "config_user_list", label: "Config. · Lista de usuários", group: "Configuração (abas)", path: "/autentico/config", allowedLevels: ["admin", "coordinator"] },
  { id: "config_nfc", label: "Config. · Cartões NFC", group: "Configuração (abas)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_nfc_student_register", label: "NFC · Cadastrar estudante", group: "Config. · Cartões NFC (sub)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_nfc_student_list", label: "NFC · Consulta estudantes", group: "Config. · Cartões NFC (sub)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_nfc_employee_register", label: "NFC · Cadastrar colaborador", group: "Config. · Cartões NFC (sub)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_nfc_employee_list", label: "NFC · Consulta colaboradores", group: "Config. · Cartões NFC (sub)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_nfc_topups", label: "NFC · Recargas", group: "Config. · Cartões NFC (sub)", path: "/autentico/config", allowedLevels: ["admin", "caixa"] },
  { id: "config_nfc_statement", label: "NFC · Extrato", group: "Config. · Cartões NFC (sub)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_stock", label: "Config. · Estoque", group: "Configuração (abas)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_stock_products", label: "Estoque · Produtos", group: "Config. · Estoque (sub)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_stock_entry", label: "Estoque · Entrada de estoque", group: "Config. · Estoque (sub)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_stock_report", label: "Estoque · Relatório de estoque", group: "Config. · Estoque (sub)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_reports", label: "Config. · Relatórios", group: "Configuração (abas)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_reports_cash_closing", label: "Relatórios · Fechamento de caixa", group: "Config. · Relatórios (sub)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_reports_employee_purchases", label: "Relatórios · Compras colaboradores", group: "Config. · Relatórios (sub)", path: "/autentico/config", allowedLevels: ["admin", "coordinator", "caixa"] },
  { id: "config_menu_permissions", label: "Config. · Permissões de menu", group: "Configuração (abas)", path: "/autentico/config", allowedLevels: ["admin"] },
  { id: "grade_logs", label: "Log de notas", group: "Pedagógico", path: "/autentico/grades/logs", allowedLevels: ["admin", "coordinator", "director"] },
  { id: "planning", label: "Planejamento", group: "Pedagógico", path: "/autentico/planning", allowedLevels: ["admin", "assistant", "coordinator", "teacher", "secretary"] },
  { id: "canteen", label: "Cantina", group: "Operações", path: "/autentico/canteen", allowedLevels: ["admin", "canteen", "assistant", "coordinator", "caixa"] },
  { id: "holerites", label: "RH · Holerites", group: "RH", path: "/autentico/rh/holerites", allowedLevels: ["admin"] },
  { id: "enrollment_crm", label: "Leads / CRM matrículas", group: "Comercial", path: "/autentico/crm-matriculas", allowedLevels: ["admin", "assistant", "coordinator", "secretary", "director"] },
];

const CATALOG_BY_ID = MENU_ACCESS_CATALOG.reduce((acc, item) => {
  acc[item.id] = item;
  return acc;
}, {});

function normalizeLevel(level) {
  return (level || "").toString().toLowerCase().trim();
}

export function baselineAccessForLevel(menuId, level) {
  const item = CATALOG_BY_ID[menuId];
  if (!item) return false;
  const L = normalizeLevel(level);
  if (item.allowedLevels === null) return Boolean(L);
  return item.allowedLevels.map(normalizeLevel).includes(L);
}

/** Normaliza overrides; array legado = negações. */
export function normalizeMenuOverridesStored(raw) {
  if (raw == null) return {};
  if (Array.isArray(raw)) {
    const out = {};
    raw.forEach((id) => {
      if (typeof id === "string" && CATALOG_BY_ID[id]) out[id] = false;
    });
    return out;
  }
  if (typeof raw === "object") {
    const out = {};
    for (const [k, v] of Object.entries(raw)) {
      if (!CATALOG_BY_ID[k]) continue;
      if (v === true) out[k] = true;
      else if (v === false) out[k] = false;
    }
    return out;
  }
  return {};
}

export function resolveMenuAccess(level, menuId, overrides) {
  const ov = normalizeMenuOverridesStored(overrides);
  if (Object.prototype.hasOwnProperty.call(ov, menuId)) {
    if (ov[menuId] === false) return false;
    if (ov[menuId] === true) return true;
  }
  return baselineAccessForLevel(menuId, level);
}

export function normalizeMenuOverridesFromUser(user) {
  if (!user) return {};
  const fromObj = normalizeMenuOverridesStored(user.menuOverrides);
  const fromLegacy = normalizeMenuOverridesStored(user.menuDenials);
  return { ...fromLegacy, ...fromObj };
}

/**
 * @param {{ level?: string, menuOverrides?: object, menuDenials?: unknown }} user
 * @param {string} menuId
 */
export function staffCanAccessMenu(user, menuId) {
  if (!user?.level) return false;
  const ov = normalizeMenuOverridesFromUser(user);
  return resolveMenuAccess(user.level, menuId, ov);
}

/** Sub-abas de Cartões NFC: exige aba principal + permissão da sub-aba. */
export function staffCanAccessWalletNfcSubtab(user, subMenuId) {
  return staffCanAccessMenu(user, "config_nfc") && staffCanAccessMenu(user, subMenuId);
}

/** Sub-abas de Estoque. */
export function staffCanAccessWalletStockSubtab(user, subMenuId) {
  return staffCanAccessMenu(user, "config_stock") && staffCanAccessMenu(user, subMenuId);
}

/** Sub-abas de Relatórios (wallet). */
export function staffCanAccessWalletReportSubtab(user, subMenuId) {
  return staffCanAccessMenu(user, "config_reports") && staffCanAccessMenu(user, subMenuId);
}
